<template>
  <div v-if="!$store.state.View.takt_time_filter.active || (index > $store.state.View.takt_time_filter.start && index < $store.state.View.takt_time_filter.end)"
    class="high-lighter"
    :style="`
      left: calc((${$store.state.View.takt_time_filter.active ? index - $store.state.View.takt_time_filter.start - 1 : index} * (var(--workpackage_width) + 8px) + ${header_width}) * var(--taktplan_zoom);
      ${z_index ? `z-index: ${z_index};` : ''}
      ${border_style ? `border-right-style: ${border_style};` : ''}
      `"
  >
  </div>
</template>
<script>
export default {
  props: ['index', 'header_width', 'z_index', 'border_style'],
  data: () => ({
  }),
}
</script>
<style>
  .high-lighter {
    position: absolute;
    left: 0px;
    width: 1px;
    border-right-width: 1px;
    border-right-style: solid;
    border-color: var(--v-primary-base);
    /* background-color: var(--v-primary-base); */
    height: calc(100% + 1px);
    z-index: 4;
    transform: translateX(-0.5px);
  }
</style>
